import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { captureAttribution } from "@/lib/attribution";

import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import WhatWeDo from "@/components/landing/WhatWeDo";
import GuideCapture from "@/components/landing/GuideCapture";
import SocialChannels from "@/components/landing/SocialChannels";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import Unsubscribe from "@/pages/Unsubscribe";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <WhatWeDo />
        <GuideCapture />
        <SocialChannels />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    captureAttribution();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
